import React, { useEffect, useState } from "react";
import {
  updateFormContentPreview,
  getFormContentPreview,
  imageUploadClientPreview,
} from "../../../../api/services/services";
import { Button, Snackbar, Grid } from "@mui/material"; // Added Grid
import Typography from "@mui/material/Typography";
// Removed Row, Col from react-bootstrap
import MuiAlert from "@mui/material/Alert";
import Input from "../../../atoms/Input";
import ContactDetailField from "../../../molecules/ContactDetailField";
import DynamicText from "../../../molecules/DynamicText";
import { useLocation } from "react-router-dom";
import PrintComponent from "../../PrintComponent";
import WorksheetImportDownload from "./download";
import { Bucket } from "../../../../api/config/apiConfig";
import moment from "moment";
import PremiumPublicLayout from "../../../templates/PremiumPublicLayout";
import CommentIcon from "@mui/icons-material/Comment";
import MySignatureCanvas from "../../../molecules/signature_canvas";
import PremiumCard from "../../../molecules/PremiumCard";
import SectionHeader from "../../../molecules/SectionHeader";
import DescriptionIcon from "@mui/icons-material/Description";
import InventoryIcon from "@mui/icons-material/Inventory";
import GavelIcon from "@mui/icons-material/Gavel";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import NoteAltIcon from "@mui/icons-material/NoteAlt";


const WorksheetImportPageClientSide = () => {
  const [formContent, setFormContent] = useState({});
  const [formContentId, setFormContentId] = useState("");

  const [surveyData, setSurveyData] = useState([]);

  const [isEdit, setIsEdit] = useState(false);

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [isLoading, setIsLoading] = useState(false);

  const [mediaKeysToSend, setMediaKeysToSend] = useState([]);

  const location = useLocation();
  const urlData = new URLSearchParams(location.search);
  const email = urlData.get("email");
  const surveyId = urlData.get("surveyId");
  const formId = urlData.get("formId");
  const token = urlData.get("token");

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  //
  const updateContent = (data) => {
    setIsLoading(true);

    let media = [];
    if (formContent?.clientSign != "") media[0] = formContent?.clientSign;

    const body = {
      formContentId: formContentId,
      content: data ? data : formContent,
      mediaKeys: mediaKeysToSend,
      removedMediaKeys: [],
    };
    updateFormContentPreview(
      surveyId,
      formId,
      email,
      token,
      body,
      formContentId
    )
      .then((res) => {
        if (data != undefined)
          setSnackbarMessage("Signature has been added successfully!");
        else
          setSnackbarMessage(
            "Delivery Request Form has been updated successfully!"
          );

        setOpenSnackbar(true);
        getContent();
        setIsEdit(false);

        setIsLoading(false);
        setMediaKeysToSend([]);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          setIsValid(false);
        }

        setIsLoading(false);
      });
  };

  const [isValid, setIsValid] = useState(false);

  //
  const getContent = () => {
    setIsLoading(true);
    setMediaKeysToSend([]);
    getFormContentPreview(surveyId, formId, email, token)
      .then((res) => {
        setIsValid(true);
        setFormContentId(res.data.data.uuid);
        setFormContent(res.data.data.content);

        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          setIsValid(false);
        }

        setIsLoading(false);
      });
  };

  useEffect(() => {
    getContent();
  }, []);


  const [uploadText1, setUploadText1] = useState("Upload Sign");
  const [uploadText2, setUploadText2] = useState("Upload Sign");

  const [isSignCanvas, setSignCanvas] = useState(false);
  const [whichSign, setWhichSign] = useState("");

  //
  const uploadFile = async (file) => {
    setIsLoading(true);

    if (whichSign == "manager") setUploadText1("Uploading...");
    if (whichSign == "assist") setUploadText2("Uploading...");

    const fd = new FormData();
    fd.append("image", file);

    imageUploadClientPreview(fd, surveyId, formId, email, token)
      .then((res) => {
        let values = { ...formContent };
        if (whichSign == "manager") values.managerSign = res?.data?.data?.key;
        if (whichSign == "assist") values.assistOperSign = res?.data?.data?.key;
        setFormContent(values);

        let md = [...mediaKeysToSend];
        md.push(res?.data?.data?.key);
        setMediaKeysToSend(md);

        setIsLoading(false);

        setTimeout(() => {
          updateContent(values);
        }, 2000);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setUploadText1("Upload Sign");
        setUploadText2("Upload Sign");

        setIsLoading(false);
      });
  };

  return (
    <>
      {isValid ? (
        <PremiumPublicLayout
          title="Work Sheet Import"
          hideBackButton={true}
          actions={
            <div className="d-flex gap-3">
              {!isEdit && (
                <Button
                  variant="contained"
                  onClick={() => {
                    setIsEdit(true);
                  }}
                  disabled={isLoading}
                  sx={{
                    textTransform: "none",
                    borderRadius: "var(--radius-md)",
                    padding: "10px 24px",
                    fontWeight: 700,
                    backgroundColor: "var(--primary-color)",
                    boxShadow: "0 4px 12px rgba(79, 70, 229, 0.2)",
                    "&:hover": { backgroundColor: "var(--primary-hover)" },
                  }}
                  startIcon={<NoteAltIcon />}
                >
                  Edit
                </Button>
              )}

              {isEdit && (
                <Button
                  variant="outlined"
                  color="error"
                  onClick={() => {
                    getContent();
                    setIsEdit(false);
                  }}
                  disabled={isLoading}
                  sx={{
                    textTransform: "none",
                    borderRadius: "var(--radius-md)",
                    fontWeight: 700,
                    padding: "10px 24px",
                    border: "1px solid",
                  }}
                >
                  Cancel
                </Button>
              )}

              {isEdit && (
                <Button
                  variant="contained"
                  onClick={() => {
                    updateContent();
                  }}
                  disabled={isLoading}
                  sx={{
                    textTransform: "none",
                    borderRadius: "var(--radius-md)",
                    padding: "10px 32px",
                    fontWeight: 700,
                    backgroundColor: "var(--primary-color)",
                    boxShadow: "0 4px 12px rgba(79, 70, 229, 0.3)",
                    "&:hover": { backgroundColor: "var(--primary-hover)" },
                  }}
                >
                  Save
                </Button>
              )}

              {!isEdit && (
                <Button
                  variant="contained"
                  onClick={() => {
                    if (window.innerWidth <= 768) { if (typeof setSnackbarMessage !== "undefined" && typeof setOpenSnackbar !== "undefined") { setSnackbarMessage("For a good experience, please use a desktop screen"); setOpenSnackbar(true); } else { alert("For a good experience, please use a desktop screen"); } return; }
                      setIsLoading(true);
                    var tempTitle = document.title;
                    document.title = `Work-Sheet-Import-${
                      formContent?.customerName
                    }-${moment(new Date()).format("DD.MM.YYYY")}`;

                    // Standardized delay for print and title restoration
                    setTimeout(() => {
                      window.print();
                      setTimeout(() => {
                        document.title = tempTitle;
                        setIsLoading(false);
                      }, 2000);
                    }, 500);
                  }}
                  disabled={isLoading}
                  sx={{
                    textTransform: "none",
                    borderRadius: "var(--radius-md)",
                    padding: "10px 24px",
                    fontWeight: 700,
                    backgroundColor: "var(--text-main)",
                    boxShadow: "0 4px 12px rgba(15, 23, 42, 0.2)",
                    "&:hover": { backgroundColor: "#000" },
                  }}
                  startIcon={<DescriptionIcon />}
                >
                  Save as PDF
                </Button>
              )}
            </div>
          }
        >
          <PremiumCard sx={{ marginBottom: "32px" }}>
            <SectionHeader
              title="Customer Details"
              icon={<DescriptionIcon />}
            />
            <Grid container spacing={4}>
              <Grid item xs={12} md={6}>
                <ContactDetailField
                  label="Name"
                  isEdit={isEdit}
                  type="text"
                  minWidth={"150px"}
                  value={formContent?.customerName}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.customerName = e.target.value;
                    setFormContent(values);
                  }}
                />
                <ContactDetailField
                  label="Organization"
                  isEdit={isEdit}
                  type="text"
                  minWidth={"150px"}
                  value={formContent?.organization}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.organization = e.target.value;
                    setFormContent(values);
                  }}
                />
                <ContactDetailField
                  label="Delivery Address"
                  isEdit={isEdit}
                  type="text"
                  minWidth={"150px"}
                  value={formContent?.deliveryAddres}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.deliveryAddres = e.target.value;
                    setFormContent(values);
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <ContactDetailField
                  label="File No. "
                  isEdit={isEdit}
                  type="text"
                  minWidth={"150px"}
                  value={formContent?.fileNo}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.fileNo = e.target.value;
                    setFormContent(values);
                  }}
                  disabled={true}
                />
                <ContactDetailField
                  label="Contact No"
                  isEdit={isEdit}
                  type="number"
                  minWidth={"150px"}
                  value={
                    formContent?.contactNo != "null" &&
                    formContent?.contactNo != undefined
                      ? formContent?.contactNo
                      : ""
                  }
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.contactNo = e.target.value;
                    setFormContent(values);
                  }}
                />
                <ContactDetailField
                  label="Fax"
                  isEdit={isEdit}
                  type="number"
                  minWidth={"150px"}
                  value={formContent?.fax}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.fax = e.target.value;
                    setFormContent(values);
                  }}
                />
                <ContactDetailField
                  label="Email"
                  isEdit={isEdit}
                  type="text"
                  minWidth={"150px"}
                  value={formContent?.email}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.email = e.target.value;
                    setFormContent(values);
                  }}
                />
              </Grid>
            </Grid>
          </PremiumCard>

          <PremiumCard sx={{ marginBottom: "32px" }}>
            <SectionHeader
              title="Shipment Details"
              icon={<LocalShippingIcon />}
            />
            <Grid container spacing={4}>
              <Grid item xs={12} md={6}>
                <ContactDetailField
                  label="Entitlement"
                  isEdit={isEdit}
                  type="text"
                  minWidth="150px"
                  value={formContent?.entitlement1}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.entitlement1 = e.target.value;
                    setFormContent(values);
                  }}
                />
                <ContactDetailField
                  label="Estimated Weight"
                  isEdit={isEdit}
                  type="text"
                  minWidth="150px"
                  value={formContent?.estimatedWeight}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.estimatedWeight = e.target.value;
                    setFormContent(values);
                  }}
                />
                <ContactDetailField
                  label="Actual Weight"
                  isEdit={isEdit}
                  type="text"
                  minWidth="150px"
                  value={formContent?.actualWeight}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.actualWeight = e.target.value;
                    setFormContent(values);
                  }}
                />
                <ContactDetailField
                  label="Estimated Volume"
                  isEdit={isEdit}
                  type="number"
                  minWidth="150px"
                  value={formContent?.estimatedVolume}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.estimatedVolume = e.target.value;
                    setFormContent(values);
                  }}
                />
                <ContactDetailField
                  label="Actual Volume"
                  isEdit={isEdit}
                  type="number"
                  minWidth="150px"
                  value={formContent?.actualVolume}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.actualVolume = e.target.value;
                    setFormContent(values);
                  }}
                />
                <ContactDetailField
                  label="Delivery Started Date"
                  isEdit={isEdit}
                  type="date"
                  minWidth="150px"
                  value={formContent?.deliveryStartedDate}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.deliveryStartedDate = e.target.value;
                    setFormContent(values);
                  }}
                />
                <ContactDetailField
                  label="Delivery Completed Date"
                  isEdit={isEdit}
                  type="date"
                  minWidth="150px"
                  value={formContent?.deliveryCompletedDate}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.deliveryCompletedDate = e.target.value;
                    setFormContent(values);
                  }}
                />
                <ContactDetailField
                  label="Shifting Started Date"
                  isEdit={isEdit}
                  type="date"
                  minWidth="150px"
                  value={formContent?.shiftingStartedDate}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.shiftingStartedDate = e.target.value;
                    setFormContent(values);
                  }}
                />
                <ContactDetailField
                  label="Shifting Completed Date"
                  isEdit={isEdit}
                  type="date"
                  minWidth="150px"
                  value={formContent?.shiftingCompletedDate}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.shiftingCompletedDate = e.target.value;
                    setFormContent(values);
                  }}
                />
                <ContactDetailField
                  label="Warehouse In Date"
                  isEdit={isEdit}
                  type="date"
                  minWidth="150px"
                  value={formContent?.wareHouseInDate}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.wareHouseInDate = e.target.value;
                    setFormContent(values);
                  }}
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <ContactDetailField
                  label="Warehouse Out Date"
                  isEdit={isEdit}
                  type="date"
                  minWidth="150px"
                  value={formContent?.wareHouseOutDate}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.wareHouseOutDate = e.target.value;
                    setFormContent(values);
                  }}
                />
                <ContactDetailField
                  label="Shipment Date"
                  isEdit={isEdit}
                  type="date"
                  minWidth="150px"
                  value={formContent?.shipmentDate}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.shipmentDate = e.target.value;
                    setFormContent(values);
                  }}
                />
                <ContactDetailField
                  label="Origin / Destination"
                  isEdit={isEdit}
                  type="text"
                  minWidth="150px"
                  value={formContent?.originDestination}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.originDestination = e.target.value;
                    setFormContent(values);
                  }}
                />
                <ContactDetailField
                  label="BOL/AWB No."
                  isEdit={isEdit}
                  type="text"
                  minWidth="150px"
                  value={formContent?.bolAWBNo}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.bolAWBNo = e.target.value;
                    setFormContent(values);
                  }}
                />
                <ContactDetailField
                  label="Container No."
                  isEdit={isEdit}
                  type="text"
                  minWidth="150px"
                  value={formContent?.containerNo}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.containerNo = e.target.value;
                    setFormContent(values);
                  }}
                />
                <ContactDetailField
                  label="Vessel"
                  isEdit={isEdit}
                  type="text"
                  minWidth="150px"
                  value={formContent?.vessel}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.vessel = e.target.value;
                    setFormContent(values);
                  }}
                />
                <ContactDetailField
                  label="ETD/ETA"
                  isEdit={isEdit}
                  type="date"
                  minWidth="150px"
                  value={formContent?.ETDbyETA}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.ETDbyETA = e.target.value;
                    setFormContent(values);
                  }}
                />
                <ContactDetailField
                  label="ETA"
                  isEdit={isEdit}
                  type="date"
                  minWidth="150px"
                  value={formContent?.ETA}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.ETA = e.target.value;
                    setFormContent(values);
                  }}
                />
                <ContactDetailField
                  label="Airline"
                  isEdit={isEdit}
                  type="text"
                  minWidth="150px"
                  value={formContent?.airline}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.airline = e.target.value;
                    setFormContent(values);
                  }}
                />
                <ContactDetailField
                  label="Flight No."
                  isEdit={isEdit}
                  type="text"
                  minWidth="150px"
                  value={formContent?.flightNo}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.flightNo = e.target.value;
                    setFormContent(values);
                  }}
                />
              </Grid>
            </Grid>
          </PremiumCard>

          {/* Remarks */}
          <PremiumCard sx={{ marginBottom: "32px" }}>
            <SectionHeader title="Remarks" icon={<CommentIcon />} />
            <div className="mb-4">
              <DynamicText
                label="Remarks / Instructions (If any)"
                textAreaLabel="Reamarks"
                isEdit={isEdit}
                value={formContent?.remarks}
                onChange={(e) => {
                  let values = { ...formContent };
                  values.remarks = e.target.value;
                  setFormContent(values);
                }}
              />
            </div>
          </PremiumCard>

          {/* Signatures */}
          <PremiumCard sx={{ marginBottom: "32px" }}>
            <SectionHeader title="Authorization" icon={<GavelIcon />} />
            <Grid container spacing={4} className="mt-4">
              <Grid item xs={12} sm={6} className="mt-4 text-center">
                <div
                  style={{ height: "90px" }}
                  className="d-flex justify-content-center align-items-end"
                >
                  {formContent?.managerSign?.trim()?.length == 0 ? (
                    <>
                      {isEdit && (
                        <div className="d-flex justify-content-center align-items-end">
                          <label
                            htmlFor="uploadSign"
                            className="active-btn ms-2 w-200 d-flex align-items-center justify-content-center cursor-pointer btn"
                          >
                            {uploadText1}
                          </label>
                          <input
                            type="button"
                            hidden
                            id="uploadSign"
                            name="uploadSign"
                            onClick={() => {
                              setWhichSign("manager");
                              setSignCanvas(true);
                            }}
                          />
                        </div>
                      )}
                    </>
                  ) : (
                    <img
                      src={`${Bucket}${formContent?.managerSign}`}
                      height={80}
                      alt="Manager Sign"
                      style={{
                        maxHeight: "80px",
                        maxWidth: "100%",
                        objectFit: "contain",
                      }}
                    />
                  )}
                </div>

                <div
                  style={{
                    borderTop: "1px solid #000",
                    marginTop: "10px",
                    width: "80%",
                    margin: "10px auto",
                  }}
                ></div>
                <p className="my-1 text-center">
                  <b>{"Manager Operations"}</b>
                </p>
              </Grid>
              <Grid item xs={12} sm={6} className="mt-4 text-center">
                <div
                  style={{ height: "90px" }}
                  className="d-flex justify-content-center align-items-end"
                >
                  {formContent?.assistOperSign?.trim()?.length == 0 ? (
                    <>
                      {isEdit && (
                        <div className="d-flex justify-content-center align-items-end">
                          <label
                            htmlFor="uploadSign2"
                            className="active-btn ms-2 w-200 d-flex align-items-center justify-content-center cursor-pointer btn"
                          >
                            {uploadText2}
                          </label>
                          <input
                            type="button"
                            hidden
                            id="uploadSign2"
                            name="uploadSign2"
                            onClick={() => {
                              setWhichSign("assist");
                              setSignCanvas(true);
                            }}
                          />
                        </div>
                      )}
                    </>
                  ) : (
                    <img
                      src={`${Bucket}${formContent.assistOperSign}`}
                      height={80}
                      alt="Assist Sign"
                      style={{
                        maxHeight: "80px",
                        maxWidth: "100%",
                        objectFit: "contain",
                      }}
                    />
                  )}
                </div>
                <div
                  style={{
                    borderTop: "1px solid #000",
                    marginTop: "10px",
                    width: "80%",
                    margin: "10px auto",
                  }}
                ></div>
                <p className="my-1 text-center">
                  <b>{"Assistant Operations"}</b>
                </p>
              </Grid>
            </Grid>
          </PremiumCard>
        </PremiumPublicLayout>
      ) : (
        <div className="no-print">
          {isLoading ? (
            <div> Loading...</div>
          ) : (
            <div> Ooops... Something went wrong...</div>
          )}
        </div>
      )}

      <PrintComponent>
        <WorksheetImportDownload
          surveyData={surveyData}
          formContent={formContent}
        />
      </PrintComponent>

      {/* snackbar */}
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000} // Adjust the duration as needed
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity={
            snackbarMessage?.includes("successful") ? "success" : "error"
          }
          onClose={handleCloseSnackbar}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
      {/* /snackbar */}

      {/* Add signature Modal */}
      {isSignCanvas && (
        <MySignatureCanvas
          open={isSignCanvas}
          onClose={() => {
            setSignCanvas(false);
          }}
          onSuccess={(file) => {
            if (!isLoading) uploadFile(file);
          }}
        />
      )}
    </>
  );
};
export default WorksheetImportPageClientSide;
